import React from 'react';

export default function Footer({ t, lang }) {
  if (!t) return null;

  const scrollToAssistantAndCook = (e) => {
    e.preventDefault();
    document.getElementById('aiAssistantSection')?.scrollIntoView({ behavior: 'smooth' });
    const chips = document.querySelectorAll('.tg-quick-chip');
    if (chips && chips.length > 0) {
      chips[0].click();
    }
  };

  const handleFilterRegion = (regionName) => {
    document.getElementById('recipesSection')?.scrollIntoView({ behavior: 'smooth' });
    const select = document.querySelector('.region-dropdown');
    if (select) {
      select.value = regionName;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand Info */}
          <div className="footer-brand">
            <div className="brand-wrap">
              <div className="brand-icon">👩‍🍳</div>
              <div className="brand-text">
                <h2>{t.siteTitle}</h2>
                <span>{t.siteTagline}</span>
              </div>
            </div>
            <p style={{ marginTop: '14px', lineHeight: '1.6' }}>
              {t.footerDesc}
            </p>
          </div>

          {/* Column 1: Quick Links */}
          <div className="footer-col">
            <h5>{t.footerCol1Title}</h5>
            <ul>
              <li><a href="#hero">{t.fHome}</a></li>
              <li><a href="#aiAssistantSection">{t.fAssistant}</a></li>
              <li><a href="#recipesSection">{t.fRecipes}</a></li>
              <li><a href="#communitySection">{t.navCommunity || 'Community Feed'}</a></li>
              <li><a href="#pantrySection">{t.fPantry}</a></li>
              <li><a href="#plannerSection">{t.fPlanner}</a></li>
            </ul>
          </div>

          {/* Column 2: AI Features */}
          <div className="footer-col">
            <h5>{t.footerCol2Title}</h5>
            <ul>
              <li>
                <a href="#aiAssistantSection" onClick={scrollToAssistantAndCook}>
                  ✨ {t.fCookToday}
                </a>
              </li>
              <li><a href="#recipesSection">⚖️ {t.fPortionScaler}</a></li>
              <li><a href="#pantrySection">🥬 {t.fPantryMatcher}</a></li>
              <li><a href="#recipesSection">👩‍🍳 {t.fMasterclass}</a></li>
              <li><a href="#plannerSection">📋 {t.fGroceryList}</a></li>
            </ul>
          </div>

          {/* Column 3: Regional Cuisines */}
          <div className="footer-col">
            <h5>{t.footerCol3Title}</h5>
            <ul>
              <li>
                <a href="#recipesSection" onClick={(e) => { e.preventDefault(); handleFilterRegion('Tamil Nadu'); }}>
                  🌴 {t.fTamilNadu}
                </a>
              </li>
              <li>
                <a href="#recipesSection" onClick={(e) => { e.preventDefault(); handleFilterRegion('Kerala'); }}>
                  🥥 {t.fKerala}
                </a>
              </li>
              <li>
                <a href="#recipesSection" onClick={(e) => { e.preventDefault(); handleFilterRegion('Andhra'); }}>
                  🌶 {t.fAndhra}
                </a>
              </li>
              <li>
                <a href="#recipesSection" onClick={(e) => { e.preventDefault(); handleFilterRegion('Punjab'); }}>
                  🍛 {t.fNorthIndian}
                </a>
              </li>
              <li>
                <a href="#recipesSection" onClick={(e) => { e.preventDefault(); handleFilterRegion('Global'); }}>
                  🌏 {t.fGlobal}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom Bar */}
        <div className="footer-bottom">
          <div>{t.fCopyright}</div>
          <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
            <a href="#hero" style={{ color: 'var(--tg-blue)', textDecoration: 'none', fontWeight: '600' }}>
              {t.fBackToTop}
            </a>
            <span style={{ color: 'var(--text-dim)' }}>|</span>
            <span>{t.fBadge}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
